import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';

@Injectable()
export class LoginGuard  
{
    
    constructor(private loginService : LoginService,private router: Router )
    {
        
    }


    canActivate():boolean
    {
        var isOk:boolean = this.loginService.isUserLoged();
        if (!isOk)
            this.router.navigate(['']);
        return isOk;

    }

}
